import React from "react";
import { Link } from "react-router-dom";
import ProductCard from "./ProductCard";
import { useTranslation } from "react-i18next";

const RecommendedOne = ({ bestSellerProducts = [] }) => {
  const { t } = useTranslation();

  return (
    <section className="recommended margin-100">
      <div className="container">
        <div className="section-heading flex-between flex-wrap">
          <h5 className="mb-0">{t("topSellingProducts")}</h5>
          <Link
            to="/products"
            className="btn btn-main-two fw-medium d-inline-flex align-items-center rounded-pill gap-8"
          >
            {t("shopNow")}
            <span className="icon text-xl d-flex">
              <i className="ph ph-arrow-right"></i>
            </span>
          </Link>
        </div>
        <div className="row g-12">
          {bestSellerProducts.length === 0 ? (
            <div className="text-center">
              <img className="" src="/assets/images/grey.png" alt="" />
              <p className="">The data is not available for the region you are from.</p>
            </div>
          ) : (
            bestSellerProducts.map((item) => (
              <ProductCard item={item} key={item._id} className="col-lg-3 col-sm-4 col-6" />
            ))
          )}
        </div>
      </div>
    </section>
  );
};

export default RecommendedOne;
